import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=486b0df9&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
import style0 from "./Article.vue?vue&type=style&index=0&id=486b0df9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b0df9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486b0df9')) {
      api.createRecord('486b0df9', component.options)
    } else {
      api.reload('486b0df9', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=486b0df9&scoped=true", function () {
      api.rerender('486b0df9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Article.vue"
export default component.exports